import { render, staticRenderFns } from "./PlanSubscription.vue?vue&type=template&id=6bf2779a&scoped=true"
import script from "./PlanSubscription.vue?vue&type=script&lang=js"
export * from "./PlanSubscription.vue?vue&type=script&lang=js"
import style0 from "./PlanSubscription.vue?vue&type=style&index=0&id=6bf2779a&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf2779a",
  null
  
)

export default component.exports